import { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

import { FilesReport } from "./components/FilesReport";

import { useSubscription, useUserInfo } from "store/auth/auth-store";
import Report from "./components/Report";
import { useReportsContext } from "store/reports/reportsContext";

const handleSelectForm = (reportType: string) => {
  switch (reportType) {
    case "sow":
      return <Report isSow={true} />;
    case "worker":
      return <Report isSow={false} />;
    case "files":
      return <FilesReport />;
    default:
      break;
  }
};

export default function ReportPage() {
  const [reportType, setReportType] = useState("");
  const { t } = useTranslation("reports");
  const { isKuo } = useSubscription();
  const { userInfo } = useUserInfo();
  useReportsContext().connectSocket(userInfo?.email);

  return (
    <Card style={{ padding: 20, width: "70%" }}>
      <Typography variant='h5' sx={{ mb: 5 }}>
        {t("reports")}
      </Typography>
      <FormControl fullWidth>
        <InputLabel id='select-label'>{t("report-type")}</InputLabel>
        <Select
          style={{ minWidth: 200, marginBottom: 20 }}
          label={t("report-type")}
          value={reportType}
          onChange={(value) => setReportType(value.target.value as string)}
        >
          <MenuItem value='sow'>{t("sow-report-analysis")}</MenuItem>
          <MenuItem value='worker'>{t("worker-report-analysis")}</MenuItem>
          {isKuo && (
            <MenuItem value='files'>{t("massive-files-report")}</MenuItem>
          )}
        </Select>
      </FormControl>
      {reportType && handleSelectForm(reportType)}
    </Card>
  );
}
